<script lang="ts">
  import type { LeaderboardSkillsDetailsSkillItem, SkillCategory, SkillCategorySummary } from '$lib/api/types';
  import { onMount } from 'svelte';
  import Modal from '../common/bootstrap/Modal.svelte';
  import BadgeGridItem from './BadgeGridItem.svelte';
  import TableMessage from '../TableMessage.svelte';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faCheck } from '@itdev-fortawesome/pro-solid-svg-icons/faCheck';
  import { proficiencyLevelLabel, utcNowIso } from '$lib/util';

  interface Props {
    classId: number;
    viewingSkill: LeaderboardSkillsDetailsSkillItem | null;
    category: SkillCategory;
    badgeProgress?: SkillCategorySummary;
    classStartDate: string;
    classEndDate: string;
    possibleSkillCount: number;
  }

  let {
    classId,
    classStartDate,
    classEndDate,
    viewingSkill = $bindable(),
    category,
    badgeProgress,
    possibleSkillCount,
  }: Props = $props();
  let modal: Modal;

  onMount(() => {
    modal.openModal();
  });

  const utcNow = utcNowIso();
</script>

<Modal
  bind:this={modal}
  id="skill_viewer"
  onclose={() => {
    viewingSkill = null;
  }}
>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    onclick={() => {
      modal.closeModal();
    }}
  ></button>
  <BadgeGridItem
    small
    greyscaleOnIncomplete={true}
    horizontal
    {category}
    {possibleSkillCount}
    completedSkillCount={badgeProgress?.completedSkillCount ?? 0}
  />
  <h4 class="mt-3">{viewingSkill?.skillName}</h4>
  {#if viewingSkill?.completed}
    <p><span class="badge text-bg-success"><FontAwesomeIcon icon={faCheck} class="me-1" /> Completed</span></p>
  {:else if classEndDate < utcNow}
    <TableMessage message="You did not complete this skill for this class." />
  {:else if classStartDate > utcNow}
    <TableMessage message="Class has not yet started. You will be able to log this skill when the class opens." />
  {:else}
    <TableMessage message="You have not completed this skill yet. Click the button below to log your first entry." />
  {/if}
  {#if viewingSkill?.lastRecordedProficiency !== undefined}
    <h5 class="subtle-header">Proficiency Level</h5>
    <p>{proficiencyLevelLabel(viewingSkill.lastRecordedProficiency)}</p>
  {/if}
  {#if classEndDate > utcNow && classStartDate < utcNow}
    <div class="d-grid">
      <a href="/classes/{classId}/log/{viewingSkill?.skillId}?direct" class="btn btn-primary">Log New Entry</a>
    </div>
  {/if}
</Modal>

<style>
  .btn-close {
    position: absolute;
    right: var(--bs-modal-padding);
  }
</style>
